exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect[data-v-457c4423]{position:absolute;margin-top:30px;left:0}.status-field .multiselect__content-wrapper[data-v-457c4423]{min-height:40px}", ""]);

// exports
